const application = {
    path: '/arch',
    name: 'applied',
    icon: 'icon2-1peizhiguanli',
    redirect: '/arch/architecture',
    component: () => import('@/pages/layout/appMain'),
    children: [
        // 架构
        {
            name: 'scene',
            icon: 'el-icon-bicycle',
            path: '/architecture',
            component: () => import('@/pages/applied/architecture')
        },
        // 监测区间
        {
            name: 'Proberange',
            icon: 'el-icon-truck',
            path: '/detection',
            component: () => import('@/pages/applied/detection')
        },
        /**
         * 2021-12-09 --- 待修
         * 设置打印页面
         *  */
        {
            path: '/printer',
            name: 'printer',
            icon: 'icon2-1peizhiguanli',
            hidden: true,
            component: () => import('@/pages/applied/print/PrintSetting.vue')
        },
        // 监测任务
        {
            icon: '',
            name: 'monitorTask',
            path: '/task',
            hidden: true,
            component: () => import('@/pages/applied/monitorTask/monitorTask.vue')
        },
        {
            icon: 'el-icon-s-shop',
            name: 'collectRecord',
            path: '/temprecord',
            component: () => import('@/pages/report/TempRecord/index.vue')
        },
        // 联系人
        {
            icon: 'el-icon-s-shop',
            name: 'Contact',
            path: '/contacts',
            hidden: true,
            component: () => import('@/pages/applied/contacts/Contacts.vue')
        },
        // 联系人
        {
            icon: 'el-icon-s-shop',
            name: 'Download',
            path: '/download',
            hidden: true,
            component: () => import('@/pages/applied/download/Download.vue')
        }
    ]
};
export default application;
